module.exports = __webpack_public_path__ + "media/site/images/banners/banner-solutions-tablet-19d0af784d143543f21174df0f6fbe81.svg";